export default __webpack_public_path__ + "static/media/mario13.2344a1d4.jpg";